import { Link } from 'react-router-dom'
const DropDownItem = (props) => {
    const renderItem = props.name === "Blog" ? (
        <a href={props.to} target="_blank" className="drop-down-link" onClick={() => props.closeDropDown(false)} rel="noreferrer">
            <div className="drop-down-item">
                {props.name}
            </div>
        </a>
    ) : (
        <Link to={props.to} className="drop-down-link" onClick={() => props.closeDropDown(false)}>
            <div className="drop-down-item">
                {props.name}
            </div>
        </Link>
    )
    
    return renderItem
}

export default DropDownItem